import Badge from 'common/components/Badge';
import { lgBaseColors } from 'uiLivi/styles';
import IconRole from '../assets/IconRole.svg';

export default function RoleBadge({ role }) {
  return <Badge text={role} color={lgBaseColors.grey.medium} Icon={IconRole} />;
}
